export enum FilterType {
  POINTS_ADDED = 'points-added',
  POINTS_REDEEMED = 'points-redeemed',
  POINTS_EXPIRED = 'points-expired',
  POINTS_DATE_RANGE = 'points-date-range',
  REWARDS_SORT_BY = 'sort-by',
  REWARDS_FEATURED = 'featured',
  REWARDS_MY_PRINTERS = 'my-printers',
  REWARDS_CUSTOMER_SERVICE = 'customer-service',
  REWARDS_PRODUCTS = 'products',
  COUPONS_ACTIVE = 'active',
  COUPONS_REDEEMED = 'redeemed',
  COUPONS_CANCELED = 'canceled',
  COUPONS_EXPIRED = 'expired',
  GLOBAL = 'global',
  ALL_SERIES = 'all-series',
  SERIES_FILTER = 'series',
}
